import { apiEndpoints as baseEnvActions } from "src/utils/api";


export const environment = {
    production: false,
    baseUrl: 'https://dev-api.hoppyapp.io/api',
    actions: baseEnvActions,
    firebaseApiKey: 'AIzaSyD9l6NAWwjn1ZUM9vfrUKV1I-X6AB1cywM'
};
